module.exports = __webpack_public_path__ + "img/icon-forum.9591a886.svg";